import React, { useEffect, useState } from "react";
import { useDate } from "../../customHooks/useDate";
import Settings from "../Settings/Settings";

import TodoCreation from "../TodoCreation/TodoCreation";
import TodoList from "../TodoList/TodoList";

import lang from "../../lang/lang";

import {
  HomePageHeader,
  HomePageWrapper,
  HeaderGreeting,
  HeaderTime,
  HomePageMain,
  HomePageMenuHeaderStyled,
  LogoStyled,
  SettingsStyled,
} from "./HomePage.styled";

const HomePage = () => {
  const [userName, setUserName] = useState("");
  const [settingsIsOpen, setSettingsIsOpen] = useState(false);
  const { time, fullDate } = useDate();
  const [langState, setLangState] = useState(
    localStorage.getItem("language") || "en"
  );

  useEffect(() => {
    if (localStorage.getItem("userName")) {
      setUserName(localStorage.getItem("userName"));
    }
    if (localStorage.getItem("settingsIsOpen")) {
      setSettingsIsOpen(JSON.parse(localStorage.getItem("settingsIsOpen")));
    }
  }, []);

  const handleSettingsClick = () => {
    setSettingsIsOpen(!settingsIsOpen);
    localStorage.setItem("settingsIsOpen", !settingsIsOpen);
  };

  return (
    <>
      <HomePageMenuHeaderStyled>
        <LogoStyled>
          <span>Todo App</span>
        </LogoStyled>
        <SettingsStyled>
          <button
            title={
              langState === "uk" ? lang.uk.settingsTitle : lang.en.settingsTitle
            }
            onClick={handleSettingsClick}
          >
            <span className="icon-settings"></span>
          </button>
        </SettingsStyled>
      </HomePageMenuHeaderStyled>
      <HomePageWrapper>
        <HomePageHeader>
          <HeaderGreeting>
            <span>{userName ? `Hello, ${userName}! 👋` : "Hello! 👋"}</span>
          </HeaderGreeting>
          <HeaderTime>
            <span>{time}</span>
            <span>{fullDate}</span>
          </HeaderTime>
        </HomePageHeader>
        {settingsIsOpen ? (
          <Settings />
        ) : (
          <HomePageMain>
            <TodoCreation />
            <TodoList />
          </HomePageMain>
        )}
      </HomePageWrapper>
    </>
  );
};

export default HomePage;
